module.exports = __webpack_public_path__ + "img/banner4.1850755c.png";